import { Icon, IconName, IconSize } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { colors } from '@ardoq/design-tokens';
import { IHeaderParams } from 'ag-grid-enterprise';
import { InventoryContext } from '../types';
import { APIComponentAttributes } from '@ardoq/api-types';
import { t } from '@ardoq/i18n';

type CalculatedFieldHeaderProps = IHeaderParams<
  APIComponentAttributes,
  InventoryContext
>;

export const CalculatedFieldHeader = (props: CalculatedFieldHeaderProps) => {
  // AG Grid external-lib callback: read locale from context per render so
  // refreshHeader() picks up the latest translation without dep churn.
  const i18nLocale = props.context?.i18nLocale ?? {};
  const label = t(
    i18nLocale,
    'inventoryApp:ag.header.calculatedField',
    'Calculated field'
  );
  return (
    <FlexBox align="center" gap="xsmall" flexShrink={0}>
      <span>{props.displayName}</span>
      <FlexBox
        align="center"
        justify="center"
        borderRadius="small"
        padding="xxsmall"
        style={{ backgroundColor: colors.green100 }}
      >
        <Icon
          iconName={IconName.CALCULATOR}
          iconSize={IconSize.SMALL}
          color={colors.green700}
          role="img"
          aria-label={label}
          aria-hidden={false}
          data-tooltip-text={label}
        />
      </FlexBox>
    </FlexBox>
  );
};
